import type { ComponentType, SVGProps } from 'react';
import {
  Award, BarChart3, Bell, BookOpen, Briefcase, Building2, Calendar, CalendarCheck,
  ClipboardCheck, Compass, Coins, FileCheck2, FilePlus, FileSignature, FileSpreadsheet,
  FileText, Flag, FolderCheck, GraduationCap, Handshake, HeartPulse, HelpCircle, House,
  IdCard, Inbox, LayoutDashboard, Library, LineChart, ListChecks, Lock, Mic, Network,
  Receipt, Rocket, ScrollText, Send, Settings as SettingsIcon, ShieldAlert, ShieldCheck, Sparkles,
  Star, Tags, Target, User, UserCheck, UserCog, Users, Wallet, Wrench, Zap,
} from 'lucide-react';

type IconCmp = ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>;

/**
 * Canonical map: nav.ts `icon` string -> lucide component.
 * Only names actually referenced by NAV are listed; adding a new nav item
 * with an unmapped icon renders no glyph (label stays visible).
 *
 * Page 61/N — nav completeness audit expanded this map: added 16 icons
 * for the sidebar items added to student/tpo/group/company/faculty/hod/
 * principal shells so every role has full coverage of its role's pages.
 */
export const NAV_ICONS: Record<string, IconCmp> = {
  'award': Award,
  'bar-chart-3': BarChart3,
  'bell': Bell,
  'book-open': BookOpen,
  'briefcase': Briefcase,
  'building-2': Building2,
  'calendar': Calendar,
  'calendar-check': CalendarCheck,
  'clipboard-check': ClipboardCheck,
  'coins': Coins,
  'compass': Compass,
  'file-check-2': FileCheck2,
  'file-plus': FilePlus,
  'file-signature': FileSignature,
  'file-spreadsheet': FileSpreadsheet,
  'file-text': FileText,
  'flag': Flag,
  'folder-check': FolderCheck,
  'graduation-cap': GraduationCap,
  'handshake': Handshake,
  'heart-pulse': HeartPulse,
  'help-circle': HelpCircle,
  'house': House,
  'id-card': IdCard,
  'inbox': Inbox,
  'layout-dashboard': LayoutDashboard,
  'library': Library,
  'line-chart': LineChart,
  'list-checks': ListChecks,
  'lock': Lock,
  'mic': Mic,
  'network': Network,
  'receipt': Receipt,
  'rocket': Rocket,
  'scroll-text': ScrollText,
  'send': Send,
  'settings': SettingsIcon,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'sparkles': Sparkles,
  'star': Star,
  'tags': Tags,
  'target': Target,
  'user': User,
  'user-check': UserCheck,
  'user-cog': UserCog,
  'users': Users,
  'wallet': Wallet,
  'wrench': Wrench,
  'zap': Zap,
};
